var default_1 = /** @class */ (function () {
    function default_1() {
        this.Toggle();
    }
    default_1.prototype.Toggle = function () {
        var tags = document.querySelector('.footer-tags');
        var tagsBtn = document.querySelector('.btn-tags');
        var toggleTags = function (e) {
            tags.classList.toggle('open');
            tagsBtn.classList.toggle('open');
        };
        var setTagsToggle = function () {
            var tagsHeight = tags.clientHeight;
            if (tagsHeight < 150) {
                tagsBtn.classList.add('hidden');
            }
        };
        if (tagsBtn) {
            tagsBtn.onclick = toggleTags;
            setTagsToggle();
        }
    };
    return default_1;
}());
export default default_1;
